/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ArtistRemixContestSubmissionsNotificationActionData
 */
export interface ArtistRemixContestSubmissionsNotificationActionData {
    /**
     * 
     * @type {string}
     * @memberof ArtistRemixContestSubmissionsNotificationActionData
     */
    eventId: string;
    /**
     * 
     * @type {number}
     * @memberof ArtistRemixContestSubmissionsNotificationActionData
     */
    milestone: number;
    /**
     * 
     * @type {string}
     * @memberof ArtistRemixContestSubmissionsNotificationActionData
     */
    entityId: string;
}

/**
 * Check if a given object implements the ArtistRemixContestSubmissionsNotificationActionData interface.
 */
export function instanceOfArtistRemixContestSubmissionsNotificationActionData(value: object): value is ArtistRemixContestSubmissionsNotificationActionData {
    let isInstance = true;
    isInstance = isInstance && "eventId" in value && value["eventId"] !== undefined;
    isInstance = isInstance && "milestone" in value && value["milestone"] !== undefined;
    isInstance = isInstance && "entityId" in value && value["entityId"] !== undefined;

    return isInstance;
}

export function ArtistRemixContestSubmissionsNotificationActionDataFromJSON(json: any): ArtistRemixContestSubmissionsNotificationActionData {
    return ArtistRemixContestSubmissionsNotificationActionDataFromJSONTyped(json, false);
}

export function ArtistRemixContestSubmissionsNotificationActionDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): ArtistRemixContestSubmissionsNotificationActionData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'eventId': json['event_id'],
        'milestone': json['milestone'],
        'entityId': json['entity_id'],
    };
}

export function ArtistRemixContestSubmissionsNotificationActionDataToJSON(value?: ArtistRemixContestSubmissionsNotificationActionData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'event_id': value.eventId,
        'milestone': value.milestone,
        'entity_id': value.entityId,
    };
}

